import Icon520 from "../../../shared/icons/mowers/520.png";
import Icon520Epos from "../../../shared/icons/mowers/520Epos.png";
import Icon535AWDEpos from "../../../shared/icons/mowers/535AWDEpos.png";
import Icon550 from "../../../shared/icons/mowers/550.png";
import Icon550Epos from "../../../shared/icons/mowers/550Epos.png";
import Icon560Epos from "../../../shared/icons/mowers/560Epos.png";
import Icon580Epos from "../../../shared/icons/mowers/580Epos.png";
import Icon580LEpos from "../../../shared/icons/mowers/580LEpos.png";
import IconCeora544 from "../../../shared/icons/mowers/Ceora544.png";
import IconCeora546 from "../../../shared/icons/mowers/Ceora546.png";
import Icon535AWD from "../../../shared/icons/mowers/535.png";
import Icon540 from "../../../shared/icons/mowers/540Epos.png";

export const GetMowerIconSrc = (productId : string) => {
  // Note that productIDs needs to be lowercase for the comparison to work
  switch (productId) {
    case "18c29ce6-ebba-450d-86ce-18dce7bf5056": return	Icon535AWDEpos;
    case "96b0872e-7890-4642-b5e9-1acb11c06e27": return	IconCeora546;
    case "65454c87-7c49-43da-bdab-1cece6773c82": return	Icon560Epos;
    case "a4e67b1d-1f61-470c-9fc6-33b99bb0fb68": return	Icon550Epos;
    case "bfa3953e-cebc-4277-9f5c-397cbe789ab5": return	Icon520;
    case "ee77e217-32a0-4eec-be56-543d14a56fd1": return	IconCeora546;
    case "affecad5-161a-4419-86f0-76cdc4e6049f": return	Icon520;
    case "dd4d8aa1-8aa7-49af-a6fe-a198d727ecf6": return	Icon580Epos;
    case "ffe2afae-85e6-40cd-99b3-ac7fd454bea7": return	Icon550Epos;
    case "104e927d-a0a5-4fc4-99e7-b0a0d2652bf5": return	Icon580LEpos;
    case "157a3c7b-05e4-4726-903b-d85a6f865d85": return	IconCeora546;
    case "d0adaa2f-fb01-41e7-bd1b-d974e89698e5": return	IconCeora544;
    case "89ce7924-010d-4ca9-ace0-ddad7166b219": return	Icon550;
    case "267cb543-0765-4bc3-a428-f01d2ca17da6": return	Icon550;
    case "b10bdf4c-ed22-46f1-b91f-f83ae28faaaa": return	IconCeora544;
    case "681ae7c9-2914-4bfd-96ac-fe35bdb27fbb": return	Icon535AWD;
    case "79e6da7c-048a-4e31-b9e7-a47499cd01e8": return Icon520Epos;
    case "43c39414-66ad-4033-8123-9b61749edc8e": return Icon520Epos;
    case "a8f3c5d2-4e7b-4a9f-b8c6-1d2e3f4a5b6c": return Icon540;
  }
  return IconCeora546;
}